import $ from 'jquery'
import EnCours from '@/views/consultations/en-cours'
import Historique from '@/views/consultations/historique'
import DossierMedical from '@/views/dossierMedical/dossier-medical'
import TraitementEnCours from '@/views/consultations/en-cours/protocole-soins/traitement-en-cours'

import store_patient from "@/store/mods/patients/patient"

// importing patient datas
import PatientProfileBasic from '@/views/patientInfo/patient-profile-basic'
import PatientInfoPerso from '@/views/patientInfo/infos-personnels-tab-content'
import ProfilTabMenu from '@/views/patientInfo/profile-tabs-menu'

import ResultatPatient from '@/views/analyse/registre_analyse/resultat-patient'

// Travailleurs components
import TravailleurVisitePoste from '@/views/mdt/travailleurs/t-visite-poste'
import TravailleurVisiteMedicale from '@/views/mdt/travailleurs/t-visite-medicale'
import TravailleurAttReprise from '@/views/mdt/travailleurs/t-att-reprise'

import PrintComponents from '@/components/print-components'

export default {
    fields: [{ key: 'index', label: 'N°' }, { key: 'champs', label: 'Champs modifiés' }],
    name: 'patient-info',
    components: {
        EnCours, DossierMedical, PatientProfileBasic, ProfilTabMenu,
        PatientInfoPerso, Historique, TravailleurVisitePoste, TravailleurVisiteMedicale,
        TravailleurAttReprise, TraitementEnCours,
        ResultatPatient, PrintComponents
    },
    props: ["consultation"],

    data() {
        return {
            user_role: '',
            patient_id: 0,
            can_see_consultation: false,

            is_loading: true,
            data_is_available: false,
            traitement_view_toggler: 0,
            info_personne_a_prevenir: {
                personne_a_prevenir_nom: '',
                personne_a_prevenir_prenom: '',
                personne_a_prevenir_profession: '',
                personne_a_prevenir_quartier: '',
                personne_a_prevenir_telephone: ''
            },
            pers_a_prevenir_loading: true,
            can_print: false,
            view_result_loading: false,
            results: null,
            user_info: {},
            c_loading: true,
        }
    },

    watch: {
        can_print_result() {
            if (this.can_print_result == true) {
                this.printResultatPatient()
            }
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        /**
         * User Active role
         * @returns 
         */
        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return this.$store.getters['patient'];
        },

        patientHistorique() {
            return this.$store.getters['historiques']
        },

        consultationEnCours() {
            return this.$store.getters['consultationPatientEnCours']
        },

        liste_access_checker_type_consultation() {
            return this.$store.getters['liste_access_checker_type_consultation'];
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },

        can_print_result() {
            return this.$store.getters['can_print_result']
        },

        resulat_patient_to_print() {
            return this.$store.getters['resulat_patient_to_print']
        },

        add_result_loader() {
            return this.$store.getters['add_result_loader']
        },
    },

    mounted() {
        this.user_info = {
            id: this.userCredentials.id,
            user: this.userCredentials.name,
            titre: this.userCredentials.titre
        }
        this.user_role = this.activeRole.nom;
        this.patient_id = this.$route.params.id

        // GET PATIENT INFO
        this.getPatientInfo()

        this.getConsultationEnCoursByTypeConsultation()

        this.$store.dispatch("getHistorique", this.$route.params.id)

        this.$store.commit("SET_CAN_PRINT_RESULT", false)
    },

    methods: {
        getPersonneAprevenir() {
            this.pers_a_prevenir_loading = true
            store_patient.getInfoPersonneAPrevenir(this.$route.params.id).then((info_personne_a_prevenir) => {
                
                if (info_personne_a_prevenir.length == 0) {
                    this.info_personne_a_prevenir = {
                        personne_a_prevenir_nom: '',
                        personne_a_prevenir_prenom: '',
                        personne_a_prevenir_profession: '',
                        personne_a_prevenir_quartier: '',
                        personne_a_prevenir_telephone: ''
                    }
                } else {
                    this.info_personne_a_prevenir = info_personne_a_prevenir
                }

                this.pers_a_prevenir_loading = false
            })
        },

        getConsultationEnCoursByTypeConsultation() {
            this.c_loading = true
            this.selected_consultation_encours.user_id = this.userCredentials.id
            const param = {...this.selected_consultation_encours}

            this.$store.dispatch('getConsultationPatientEnCours', param).then(() => {
                if (this.consultationEnCours.length == 0) {
                    this.can_see_consultation = false
    
                    if (this.data_is_available) {
                        if (this.$refs.historiqueConsultation) {
                            this.$refs.historiqueConsultation.click() 
                        }
                    }
                    
                } else {
                    let data = {
                        auth_id: this.userCredentials.id,
                        data_type: 'type_consultation'
                    }
    
                    if (this.$route.params.consultation == "consulter" || this.$route.params.consultation == "traitement-encours") {
                        this.$store.dispatch('getAccessCheckerToTypePrestation', data).then(() => {
                            // L'on vérifie si l'utilisateur connecté a l'habileté de consulter un patient 
                            // pour le type de consultation en question
    
                            let type_consultation_id = this.consultationEnCours.tarif_consultation.type_consultation.id
                            if (this.liste_access_checker_type_consultation.includes(type_consultation_id)) {
                                this.can_see_consultation = true
    
                                if (this.data_is_available) {
                                    setTimeout(() => {
                                        if (this.$route.params.consultation == "consulter") {
                                            if (this.selected_consultation_encours.view_treatment && this.selected_consultation_encours.view_treatment == 1) {
                                                this.$refs.traitementEnCours.click()
                                            } else {
                                                this.$refs.consultationEnCours.click() 
                                            }
                                        }
                                    }, 500);
    
                                }
                            } else {
                                this.can_see_consultation = false
                                this.$refs.p_profil.click()
                            }
                        })
                    } else if (this.$route.params.consultation == "travailleur") {
                        // si un profil de médécine clinique se connecte ici
                        if (this.user_role == 'ROLE_MEDECIN' || this.user_role == 'ROLE_INFIRMIER') {
                            this.$router.push({ path: '/patients/' + this.$route.params.id + '/consulter' })
                        }
                    }
                }
                this.c_loading = false
                
                this.getPersonneAprevenir()
            })
        },

        /**
         * Set active tab
         * @param {*} tabindex 
         */
        changeTab(tabindex, t) {

            if (t == 1) {
                $('#shown-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 10; i++) {
                    if (i != tabindex) {
                        $('#shown-tab-' + i).removeClass('active show');
                    }
                }
            } else {
                $('#hidden-tab-' + tabindex).addClass('active show');

                for (let i = 1; i <= 10; i++) {
                    if (i != tabindex) {
                        $('#hidden-tab-' + i).removeClass('active show');
                    }
                }
            }

            if (tabindex == '10' && t == '2') {
                this.toggleTraitementView()
            }
            
        },

        toggleTraitementView() {
            this.traitement_view_toggler = (this.traitement_view_toggler == 0)?1:0
        },

        /**
         * Ajoute la section Examen biologique
         */
        addAnalyse() {
            this.$refs.cours.addAnalyse()
        },

        /**
         * Ajoute la section CONDITION A TENIR
         */
        addCAT() {
            this.$refs.cours.showCAT()
        },

        /** 
         * Ajoute la section ordonnance
         */
        addOrdonnance() {
            this.$refs.cours.showOrdonnance()
        },

        getPatientInfo() {
            this.is_loading = true
            this.$store.dispatch("getPatient", this.$route.params.id).then(() => {
                if (this.patient && this.patient.id > 0) {
                    this.data_is_available = true
                    this.is_loading = false

                    
                } else {
                    this.data_is_available  = false
                }
                this.is_loading = false
            })
        },

        printResultatPatient() {
            this.can_print = true
            this.results = this.resulat_patient_to_print
            
            setTimeout(() => {
                window.print()

                this.can_print = false
                this.$store.commit("SET_CAN_PRINT_RESULT", false)
                this.$store.commit("SET_RESULAT_PATIENT_TO_PRINT", {})
            }, 1500);
        },
    }
}